import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/DashboardSidebar';
import './ProductsAdmin.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://orders.fletaime.com';

export default function ProductsAdmin() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('dashboardAuth') !== 'true') {
      navigate('/dashboard/sign-in');
      return;
    }
    fetchProducts();
  }, [navigate]);

  const fetchProducts = () => {
    setLoading(true);
    fetch(`${API_URL}/api/products`)
      .then(r => r.json())
      .then(data => { setProducts(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`A jeni i sigurt që doni ta fshini "${name}"?`)) return;
    setDeleting(id);
    try {
      const res = await fetch(`${API_URL}/api/products/${id}`, { method: 'DELETE' });
      if (res.ok) {
        setProducts(prev => prev.filter(p => p.id !== id));
      } else {
        alert('Gabim gjatë fshirjes!');
      }
    } catch {
      alert('Gabim gjatë fshirjes!');
    }
    setDeleting(null);
  };

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-content">
        <div className="pa-header">
          <h2>Produktet</h2>
          <button className="pa-btn-add" onClick={() => navigate('/dashboard/products/add')}>
            + Shto Produkt
          </button>
        </div>

        {loading ? (
          <div className="pa-loading">Duke ngarkuar...</div>
        ) : products.length === 0 ? (
          <div className="pa-empty">Nuk ka produkte. Shto produktin e parë!</div>
        ) : (
          <div className="pa-grid">
            {products.map(p => (
              <div className="pa-card" key={p.id}>
                <div className="pa-card-img">
                  {p.image_urls && p.image_urls[0] ? (
                    <img src={p.image_urls[0]} alt={p.name} />
                  ) : (
                    <div className="pa-card-no-img">Pa foto</div>
                  )}
                </div>
                <div className="pa-card-body">
                  <div className="pa-card-category">{p.category}</div>
                  <div className="pa-card-name">{p.name}</div>
                  <div className="pa-card-price">
                    <span className="pa-price-current">€{parseFloat(p.price).toFixed(2)}</span>
                    {p.original_price && (
                      <span className="pa-price-original">€{parseFloat(p.original_price).toFixed(2)}</span>
                    )}
                  </div>
                  <div className="pa-card-actions">
                    <button
                      className="pa-btn-edit"
                      onClick={() => navigate(`/dashboard/products/edit/${p.id}`)}
                    >
                      Ndrysho
                    </button>
                    <button
                      className="pa-btn-delete"
                      onClick={() => handleDelete(p.id, p.name)}
                      disabled={deleting === p.id}
                    >
                      {deleting === p.id ? '...' : 'Fshi'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
